import httpClient from '@/libs/http-client'

export function getTopInfo (params) {
  const url = '/api/v2/main/topInfo'
  return httpClient.post(url, params).then(response => {
    return response
  })
}
